import { observer } from "mobx-react-lite"
import React, { FC } from "react"
import {
  Image,
  ImageStyle,
  Pressable,
  ViewStyle,
  TextStyle,
  Modal,
  Platform,
  Dimensions,
  Linking,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from "react-native"
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { WebView } from 'react-native-webview';
import { WebView as WebViewForWeb } from 'react-native-web-webview';
import { Input as Input2, InputField, InputSlot, ScrollView } from "@gluestack-ui/themed";
import { MaterialIcons, FontAwesome5 } from "@expo/vector-icons";

import { setupRootStore, useStores } from "../models"
import { customApp } from "../config";
import StylesApp from "./StylesApp"
import { RegisterFormScreen, ResetForm } from "./RegisterFormScreen"
import OldStore from "../utils/storage/oldStore";
import * as storage from "../utils/storage";
import * as FileSystem from 'expo-file-system';
import * as DocumentPicker from 'expo-document-picker';
import DeviceInfo from "../services/deviceInfo"

const welcomeLogo = require("../../assets/images/logo.png")


// @ts-ignore
export const LoginScreen: FC = observer(function LoginScreen(_props
) {
  const { authenticationStore, statusStore } = useStores();
  const [resetFormVisible, setResetFormVisible] = React.useState(false);
  const [webViewVisible, setWebViewVisible] = React.useState(false);
  const [registerFormVisible, setRegisterFormVisible] = React.useState(false);
  const [helpPTWVisible, setHelpPTWVisible] = React.useState(false);
  const rootStore = useStores()
  let inputPWD_ref = React.createRef()

  if (customApp.user && customApp.user != "") {
    authenticationStore.signIn({ username: customApp.user, password: customApp.pass });
    return <View></View>;
  }

  const focusPass = () => {
    // @ts-ignore
    inputPWD_ref.focus();
  }

  const sendLogs = async () => {
    statusStore.setStatus("pending");
    statusStore.clearLoadingInfo();
    statusStore.addLoadingInfo({ title: "Enviando Logs", spinner: true });
    let allKeys = await OldStore.getAllKeys();
    let _oldStorageJSON: any = {};
    if (allKeys.length > 0) {
      _oldStorageJSON["allKeys"] = JSON.stringify(allKeys);
      for (const key of allKeys) {
        _oldStorageJSON[key] = await OldStore.getItemPart(key) || "";
      }
    }

    let flname = new Date().toISOString().concat("-", customApp.packagename, '-', DeviceInfo.deviceModel, '-', await DeviceInfo.uniqueId());


    let storageJSON: any = {};
    storageJSON = {
      "oldStore": _oldStorageJSON,
      "v3-IntegrationsStore-v1": await storage.getItem("v3-IntegrationsStore-v1") || "",
      "v3-ItemsStore-v1": await storage.getItem("v3-ItemsStore-v1") || "",
      "v3-authStore-v1": await storage.getItem("v3-authStore-v1") || "",
      "v3-formsStore-v1": await storage.getItem("v3-formsStore-v1") || "",
    }
    statusStore.addLoadingInfo({ title: "Enviando Logs de Registros", spinner: true });
    let str = JSON.stringify(storageJSON);
    const data = new FormData();
    if (Platform.OS == "web") {
      let res = await fetch("data:text/plain,".concat(str));
      let blob = await res.blob();
      const file = new File([blob], flname);
      data.append(flname, file, flname)

    } else {
      const filePath = `${FileSystem.documentDirectory}/${flname}.txt`;
      await FileSystem.writeAsStringAsync(filePath, str);
      data.append(flname, {
        name: flname,
        type: "application/octet-stream",
        uri: Platform.OS === 'ios' ? filePath : `file://${filePath}`,
      });
    }
    await fetch(customApp.baseUrl.concat("api/containers/appfield-userlogs/upload/"), {
      method: "post",
      body: data,
      headers: Platform.OS == "web" ? {} : { "Content-Type": "multipart/form-data; " },
    });
    statusStore.setStatus("done");

  }

  const loadLogs = async () => {
    async function process(content) {
      const storageJSON = JSON.parse(content);
      console.log(storageJSON);
      await storage.setItem("IntegrationsStore-v1", storageJSON["v3-IntegrationsStore-v1"]);
      await storage.setItem("ItemsStore-v1", storageJSON["v3-ItemsStore-v1"]);
      await storage.setItem("authStore-v1", storageJSON["v3-authStore-v1"]);
      await storage.setItem("formsStore-v1", storageJSON["v3-formsStore-v1"]);
      await setupRootStore(rootStore)
    }
    const result = await DocumentPicker.getDocumentAsync({ multiple: false, })
    if (result.canceled)
      return;
    console.log(result);
    statusStore.setStatus("pending");
    statusStore.clearLoadingInfo()
    let fileUri = result.assets[0].uri;
    if (fileUri.substring(0, 5) == "data:") {
      //base64
      let res = await fetch(fileUri);
      let blob = await res.blob();
      let reader = new FileReader();
      await reader.readAsText(blob, 'utf8');
      reader.onload = async function () {
        await process(reader.result)
        statusStore.setStatus("done");
      }
    } else {
      let content = await FileSystem.readAsStringAsync(fileUri)
      await process(content);
      statusStore.setStatus("done");

    }

  }

  const [data, setData] = React.useState({
    username: '',
    password: '',
    check_textInputChange: false,
    secureTextEntry: true,
    isValidUser: false,
    isValidPassword: false,
  });

  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const loadLastUsername = async () => {
      try {
        const lastUser = await storage.getItem("last_username");
        if (lastUser && typeof lastUser === 'string') {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          setData(prev => ({
            ...prev,
            username: lastUser,
            check_textInputChange: re.test(lastUser),
            isValidUser: re.test(lastUser)
          }));
        }
      } catch (e) {
      } finally {
        setIsReady(true);
      }
    };
    loadLastUsername();
  }, []);

  const doLogin = async () => {
    try {
      await storage.setItem("last_username", data.username);
    } catch (e) { }
    authenticationStore.signIn({ username: data.username, password: data.password });
  };

  const handlePasswordChange = (val: string) => {
    setData({
      ...data,
      password: val,
      isValidPassword: (val.trim().length >= 3)
    });
  }

  const handleUserChange = (val: string) => {
    val = val.replace(/\s/g, '').toLowerCase();
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (val.length >= 4 && re.test(val)) {
      setData({
        ...data,
        username: val,
        check_textInputChange: true,
        isValidUser: true
      });
    } else {
      setData({
        ...data,
        username: val,
        check_textInputChange: false,
        isValidUser: false
      });
    }
  }

  const updateSecureTextEntry = () => {
    setData({
      ...data,
      secureTextEntry: !data.secureTextEntry
    });
  }

  const WebView_onMessage = (message: any) => {
    authenticationStore.signSAML(JSON.parse(message.nativeEvent.data));
  }

  const web_OpenLoginSAML = () => {
    if (Platform.OS == "web") {
      const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=600`;
      const url = `${customApp.baseUrl}sso/saml/loginWebApp?urlMS=${customApp.loginSAML?.url}`;
      const newWindow = window.open(url, "Login Ms Azure", params);
      window.addEventListener('message', (event) => {
        if (event.data?.user) {
          authenticationStore.signSAML(event.data);
          newWindow.close();
        }
      });
    } else {
      setWebViewVisible(true);
    }
  }

  const html = `
  <html>
  <head></head>
  <body>
    <h1>Loading Login Provider...</h1>
    <script>
      setTimeout(function () {        
        document.location.href='${customApp.loginSAML?.url}';
      }, 100)
    </script>
  </body>
  </html>
`;

  if (!isReady) {
    return <View style={[$container, StylesApp.bgPrimary, { height: (statusStore.windowDimensions.height - 20) }]}></View>;
  }

  return (
    <View style={[$container, StylesApp.bgPrimary, { height: (statusStore.windowDimensions.height - 20) }]}>
      <View style={[$topContainer]}>
        <Image style={$welcomeLogo} source={welcomeLogo} resizeMode="contain" />
      </View>
      {(customApp.user && customApp.user != "") ?
        <Text style={{ color: "white" }}>Ingresando...</Text>
        :
        <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' enableOnAndroid={true} extraScrollHeight={100}>
          <View style={[$middleContainer]} >
            <View style={{ alignContent: "center", alignItems: "center" }}>
              
              <Input2
                variant="outline"
                size="md" bg="$gray900" borderColor={ data.isValidUser || data.username.length == 0 ? "$white" : "$red" }
                isDisabled={false} width={"90%"}
                isInvalid={data.isValidUser || data.username.length == 0 ? false : true}
                isReadOnly={false}
              >
                <MaterialIcons name="person-outline" size={24} color="#fff" style={{ marginLeft: 8 }} />                
                <InputField autoFocus={data.username.length === 0} placeholder="Email" color="#fff" onChangeText={(val) => handleUserChange(val)} onSubmitEditing={focusPass}
                  value={data.username}
                  placeholderTextColor="#ccc"
                  cursorColor="#FFF" />
              </Input2>
            </View>
            <View style={{ alignContent: "center", alignItems: "center", marginVertical: 10 }}>
              <Input2
                variant="outline"
                size="md" bg="$gray900" borderColor={data.isValidPassword || data.password.length == 0 ? "$white" : "$red"}
                isDisabled={false} width={"90%"}
                isInvalid={data.isValidPassword || data.password.length == 0 ? false : true}
                isReadOnly={false}
              >
                <MaterialIcons name="lock-outline" size={24} color="#fff" style={{ marginLeft: 8 }} />
                <InputField ref={ref => inputPWD_ref = ref}  autoFocus={data.username.length > 0} placeholder="Password" 
                  value={data.password}
                  color="#fff" type={!data.secureTextEntry ? "text" : "password"} 
                autoComplete="password"
                onChangeText={(val) => handlePasswordChange(val)} 
                onSubmitEditing={doLogin}                
                placeholderTextColor="#ccc"
                cursorColor="#FFF" />
                <InputSlot onPress={updateSecureTextEntry}>
                  <MaterialIcons name={!data.secureTextEntry ? "visibility" : "visibility-off"} size={24} color="#fff" style={{ marginRight: 8 }} />
                </InputSlot>
              </Input2>
            </View>
            <View style={{ flex: 2, flexDirection: "row", justifyContent: "flex-end", flexWrap: "wrap", paddingHorizontal: "5%" }}>
              {customApp.loginSAML == undefined || customApp.loginSAML.url == undefined ?
                <View />
                :
                <TouchableOpacity
                  key='logiSAML-btn'
                  style={[$mainButton, { marginRight: 8 }]}
                  onPress={web_OpenLoginSAML}
                >
                  <Text style={$mainButtonText}>{customApp.loginSAML?.title}</Text>
                </TouchableOpacity>
              }
              <TouchableOpacity
                style={[
                  $mainButton,
                  !(data.isValidUser && data.isValidPassword) && { opacity: 0.5 }
                ]}
                disabled={!(data.isValidUser && data.isValidPassword)}
                onPress={doLogin}
              >
                <Text style={[$mainButtonText, { fontWeight: "900" }]}>LOGIN</Text>
              </TouchableOpacity>
            </View>

            <View style={{ flex: 1, flexDirection: 'column', justifyContent: "flex-end", borderWidth: 0, flexWrap: "wrap", marginTop: 20 }} >
              <View style={{ flex: 2, flexDirection: 'row', justifyContent: "space-between", borderWidth: 0, flexWrap: "wrap", alignItems: "center", paddingHorizontal: 10 }}>
                {customApp.packagename == "com.voolks.pampaptw" ?
                  <TouchableOpacity style={$actionButton} onPress={() => { setHelpPTWVisible(true) }}>
                    <Text style={$actionButtonText}>INSTRUCTIVOS</Text>
                  </TouchableOpacity>
                  :
                  customApp.packagename == "com.voolks.cgc" ?
                  <TouchableOpacity style={$actionButton} onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/cgcpdt/CGC-PDT-Intro.mp4")}>
                    <Text style={$actionButtonText}>INSTRUCTIVO</Text>
                  </TouchableOpacity>
                  :
                  <></>
                }
                {customApp.hideResetPassword ?
                  <View />
                  :
                  <TouchableOpacity style={$actionButton} onPress={() => { setResetFormVisible(true) }}>
                    <Text style={$actionButtonText}>RESTABLECER ACCESO</Text>
                  </TouchableOpacity>
                }
                {customApp.hideRegisterButton ? <View />
                  : <TouchableOpacity style={$actionButton} onPress={() => { setRegisterFormVisible(true) }}>
                      <Text style={$actionButtonText}>REGISTRARME</Text>
                    </TouchableOpacity>
                }
                <TouchableOpacity style={$actionButton} onPress={() => { sendLogs() }}>
                  <Text style={$actionButtonText}>ENVIAR LOGS</Text>
                </TouchableOpacity>                               
              </View>
              <View style={{ flex: 2, flexDirection: 'row-reverse', borderWidth: 0, flexWrap: "nowrap", marginTop: 20, marginRight: 20 }}>
                  
              </View> 
            </View>
            <View style={{ flex: 1, flexDirection: "row-reverse", alignItems: "center", marginTop: 10, marginLeft: 20, marginRight: 20 }}>
              <TouchableOpacity style={$versionButton} onPress={() => { statusStore.setFlashMessage(customApp.baseUrl) }} onLongPress={() => { loadLogs() }}>
                <Text style={{ flexWrap: "nowrap", color: "white", fontSize: 12 }}>{customApp.version}</Text>
              </TouchableOpacity>
              <Text style={{ fontSize: 12, color: "white", flexWrap: "wrap" }}>{statusStore.windowDimensions.width.toFixed()}x{statusStore.windowDimensions.height.toFixed()}</Text>
              <MaterialIcons name="settings-overscan" size={16} color="white" style={{ marginHorizontal: 5 }} />
            </View>
          </View>
        </KeyboardAwareScrollView>
      }
      <View>
        <Modal visible={registerFormVisible} onRequestClose={() => setRegisterFormVisible(false)}>
          <View style={$modalHeader}>
            <View style={{ width: "80%" }}>
              <Text style={$modalTitle}>Registrarme</Text>
            </View>
            <TouchableOpacity onPress={() => setRegisterFormVisible(false)}>
              <MaterialIcons name="close" size={24} color="white" />
            </TouchableOpacity>
          </View>
          <ScrollView>
            <RegisterFormScreen callBack={() => { setRegisterFormVisible(false) }} ></RegisterFormScreen>
          </ScrollView>
        </Modal>
        <Modal visible={resetFormVisible} onRequestClose={() => setResetFormVisible(false)}>
          <View style={$modalHeader}>
            <View style={{ width: "80%" }}>
              <Text style={$modalTitle}>Reestablecer contraseña</Text>
            </View>
            <TouchableOpacity onPress={() => setResetFormVisible(false)}>
              <MaterialIcons name="close" size={24} color="white" />
            </TouchableOpacity>
          </View>
          <ScrollView>
            <ResetForm callBack={() => { setResetFormVisible(false) }} ></ResetForm>
          </ScrollView>
        </Modal>

        <Modal visible={helpPTWVisible} onRequestClose={() => setHelpPTWVisible(false)}>
          <View style={$modalHeader}>
            <View style={{ width: "80%" }}>
              <Text style={$modalTitle}>Instructivos</Text>
            </View>
            <TouchableOpacity onPress={() => setHelpPTWVisible(false)}>
              <MaterialIcons name="close" size={24} color="white" />
            </TouchableOpacity>
          </View>
          <ScrollView>
            <View style={{ flexDirection: "column" }}>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Documentación </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/1IqRKrADc9SsXKRSVxVsDCV0q6LTxRItQ/view?usp=drive_link")}>
                  <FontAwesome5 name="file-pdf" size={22} color={customApp.styles.primaryPalette?.["400"] || customApp.styles.primaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A1 </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/1RSbKyjnx3WyJUqhKuWGv_wDR82fcZvmy/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A1 Cadena de aprobación </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/19HqCPAnnEqwwc-p6tJ85imapRl-maxNv/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A1 - Habilitante </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A1 - Cierre del Trabajo </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A2 </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/14PTl4X_6SeYY35q8z9eNX94D02IYwxCN/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A3 </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/1IZV7c2Mg0l_TtuKfciHpGaScE35XDiHa/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
              <View style={$helpItemRow}>
                <Text style={$helpItemText}>Anexo A4 </Text>
                <TouchableOpacity onPress={() => Linking.openURL("https://drive.google.com/file/d/1tNYLKltjtscGLj2eehmb4IVqmjzQA_zF/view?usp=drive_link")}>
                  <MaterialIcons name="video-library" size={24} color={customApp.styles.secondaryPalette?.["400"] || customApp.styles.secondaryColor} />
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </Modal>
        <Modal visible={webViewVisible} onRequestClose={() => setWebViewVisible(false)}>
          <View style={$modalHeader}>
            <View style={{ width: "80%" }}>
              <Text style={$modalTitle}>{customApp.loginSAML?.title}</Text>
            </View>
            <TouchableOpacity onPress={() => setWebViewVisible(false)}>
              <MaterialIcons name="close" size={24} color="white" />
            </TouchableOpacity>
          </View>
          {Platform.OS != "web" ?
            <WebView
              source={{ html }}
              onMessage={WebView_onMessage}
            />
            :
            <WebViewForWeb
              startInLoadingState={true}
              source={{ html: `<h1>Loading Login Provider...</h1><script>document.location.href='${customApp.loginSAML?.url}';</script>` }}
              style={{ marginTop: 20, minHeight: 600 }}
              onMessage={WebView_onMessage}
              hideStatusBar={false}
              hideAddressBar={false}
              hideActivityIndicator={false}
            />
          }
        </Modal>


      </View>

    </View>
  )
})

const $primaryColor = customApp.styles.primaryPalette?.["500"] || customApp.styles.primaryColor || "#3957fc";

const $container: ViewStyle = {
  flex: 1,
  width: "100%",
  minHeight: 520,
  flexDirection: "column",
  justifyContent: "flex-end",
}

const $topContainer: ViewStyle = {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: "25%",
  justifyContent: "center",
}

const $middleContainer: ViewStyle = {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: "25%",
  justifyContent: "center",
}

const $welcomeLogo: ImageStyle = {
  height: "60%",
  width: "80%",
  maxWidth: 450,
  resizeMode: "center",
  padding: 0,
  alignSelf: "center",
}

const $mainButton: ViewStyle = {
  backgroundColor: $primaryColor,
  paddingVertical: 12,
  paddingHorizontal: 16,
  borderRadius: 6,
  alignItems: "center",
  justifyContent: "center",
  minWidth: 120,
}

const $mainButtonText: TextStyle = {
  color: "white",
  fontSize: 16,
  fontWeight: "bold",
  textAlign: "center",
}

const $actionButton: ViewStyle = {
  backgroundColor: $primaryColor,
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 4,
  margin: 4,
  alignItems: "center",
  justifyContent: "center",
}

const $actionButtonText: TextStyle = {
  color: "white",
  fontSize: 12,
  fontWeight: "600",
}

const $versionButton: ViewStyle = {
  backgroundColor: $primaryColor,
  paddingVertical: 4,
  paddingHorizontal: 8,
  borderRadius: 4,
  marginRight: 8,
}

const $modalHeader: ViewStyle = {
  backgroundColor: $primaryColor,
  paddingHorizontal: 10,
  paddingVertical: 8,
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 44,
}

const $modalTitle: TextStyle = {
  color: "white",
  fontWeight: "bold",
  fontSize: 18,
}

const $helpItemRow: ViewStyle = {
  flexDirection: "row",
  padding: 12,
  alignItems: "center",
  justifyContent: "space-between",
  borderBottomWidth: StyleSheet.hairlineWidth,
  borderBottomColor: "#eee",
}

const $helpItemText: TextStyle = {
  fontSize: 15,
  color: "#333",
}


